import styles from "./DeclinePopup.module.scss";
import { Form, FormInstance } from "antd";
import FormItemInput from "../../../components/ui/FormItemInput/FormItemInput";
import { useTranslation } from "react-i18next";
import FormItemTextArea from "../../../components/ui/FormItemTextArea/FormItemTextArea";
import React, { useRef } from "react";
import CustomButton from "../../../components/ui/CustomButton/CustomButton";
import { GymListingService } from "../../../services/gym-listing.service";
import { openSuccessMessage } from "../../../store/message/messageSlice";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { handleError } from "../../../helper/errorHandler";
import { useGymListingMutations } from "../../../api/mutations";

interface IDeclinePopupProps {
  close: () => void;
  id: string;
  setLoading: (isLoading: boolean) => void;
  getData: () => void;
}

const DeclinePopup: React.FC<IDeclinePopupProps> = ({ close, id, setLoading, getData }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const formRef = useRef<FormInstance>(null);

  const { declineGymListing } = useGymListingMutations();

  const onFinish = async (values: { title: string; description: string }) => {
    setLoading(true);
    declineGymListing(
      { id, model: values },
      {
        onSuccess: () => {
          getData();
          if (formRef.current) {
            formRef.current.setFieldsValue({
              title: null,
              description: null,
            });
          }
          dispatch(openSuccessMessage(t("GymDeclinedSuccessfully")));
          close();
        },
        onError: (e) => handleError(e, dispatch, t),
        onSettled: () => setLoading(false),
      }
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.popup}>
        <h2 className={styles.title}>{t("AddTheReasonToDecline")}</h2>
        <Form
          className={styles.form}
          ref={formRef}
          name="decline-gym-listing"
          onFinish={onFinish}
          autoComplete="off"
          layout={"vertical"}
        >
          <FormItemInput name={"title"} label={t("AddTitle")} rules={{ required: true }} />
          <FormItemTextArea
            name={"description"}
            label={t("AddReason")}
            rules={{ required: true }}
          />

          <div className={styles.btnWrapper}>
            <CustomButton
              text={t("Close")}
              type={"button"}
              typeStyle={"outline"}
              functionOnClick={close}
            />
            <CustomButton text={t("Submit")} type={"submit"} typeStyle={"fill"} />
          </div>
        </Form>
      </div>
    </div>
  );
};

export default DeclinePopup;
